define(["require", "exports", "knockout", "../utils/dateUtils", "./CPCustomerProfileDomainModel"], function (require, exports, ko, dateUtils, CPCustomerProfileDomainModel) {
    "use strict";
    var CPCustomerProfileModel = /** @class */ (function () {
        function CPCustomerProfileModel(data) {
            this.Id = ko.observable(0);
            this.Name = ko.observable();
            this.CustomerName = ko.observable();
            this.CustomerId = ko.observable();
            this.PackageName = ko.observable();
            this.PackageId = ko.observable();
            this.MaxFirewallRecords = ko.observable(2);
            this.PbxDomain = ko.observable();
            this.EnableCouterPath = ko.observable();
            this.Domains = ko.observableArray([]);
            this.DomainList = ko.observableArray([]);
            this.PackageExpirationDate = ko.observable();
            var self = this;
            if (data) {
                ko.mapping.fromJS(data, CPCustomerProfileModel.Mapping, self);
            }
        }
        CPCustomerProfileModel.prototype.newItem = function () {
            var self = this;
            if (self) {
                self.Domains.push(new CPCustomerProfileDomainModel());
            }
        };
        CPCustomerProfileModel.prototype.removeItem = function (self, item) {
            if (self && self.Domains && self.Domains().length) {
                self.Domains.remove(item);
            }
        };
        CPCustomerProfileModel.Mapping = {
            key: function (data) {
                return data.Id;
            },
            create: function (options) {
                return new CPCustomerProfileModel(options.data);
            },
            PackageExpirationDate: {
                update: function (options) { return dateUtils.parseIsoDate(options.data); }
            }
        };
        return CPCustomerProfileModel;
    }());
    return CPCustomerProfileModel;
});
//# sourceMappingURL=CPCustomerProfileModel.js.map


//////////////////
// WEBPACK FOOTER
// ./build/models/CPCustomerProfileModel.js
// module id = 73
// module chunks = 2